import { LanguageCode } from 'translations/Language'
import { resolveConversationLanguage } from '../helpers/useSystemNoticeTranslator'
import { useTranslation } from 'react-i18next'

export const useSupportHoursLocale = (): LanguageCode => {
  const { i18n } = useTranslation(['chat'])
  return resolveConversationLanguage(i18n?.language?.slice(0, 2)) ?? LanguageCode.EN
}
